import React, { useLayoutEffect, useRef, useState } from 'react';

export function queriesForRun(run) {
  if (run?.query_history?.length) return run.query_history;
  if (!run) return [];
  // Older saved runs joined requests with this internal separator.
  return (run.query || '').split('\n\nRefinement:\n').map((query, index) => ({
    query, document_name: index === 0 ? run.document_name : '',
  }));
}

export default function QueryFeed({ run, tr }) {
  const messages = queriesForRun(run);
  const feed = useRef(null);
  const latest = useRef(null);
  const [height, setHeight] = useState(null);
  const [browsing, setBrowsing] = useState(false);
  useLayoutEffect(() => {
    setBrowsing(false);
    const resize = () => {
      setHeight(Math.min(260, Math.ceil(latest.current?.offsetHeight || 80)));
      if (feed.current) feed.current.scrollTop = feed.current.scrollHeight;
    };
    resize();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(resize);
    if (latest.current) observer?.observe(latest.current);
    return () => observer?.disconnect();
  }, [run.run_id, messages.length]);
  useLayoutEffect(() => {
    if (feed.current) feed.current.scrollTop = feed.current.scrollHeight;
  }, [height, browsing]);
  return <div className="ta-query-thread">
    {messages.length > 1 && <button className="ta-query-earlier ta-link" aria-expanded={browsing} onClick={() => setBrowsing(!browsing)}>
      <i className={`fa-solid fa-chevron-${browsing ? 'down' : 'up'}`} aria-hidden="true" /> {browsing ? tr('Latest query', 'آخر طلب') : tr('Earlier queries', 'الطلبات السابقة')}</button>}
    <div className="ta-query-feed" ref={feed} style={{ height: browsing ? 'auto' : height ?? 'auto', maxHeight: 280 }} tabIndex={0} role="region" aria-label={tr('Search queries', 'طلبات البحث')}
      onScroll={(event) => {
        const element = event.currentTarget;
        // Scrolling up opens enough room to read earlier, longer requests.
        if (messages.length > 1 && !browsing && element.scrollTop < element.scrollHeight - element.clientHeight - 2) setBrowsing(true);
      }}>
      <ol>{messages.map((message, index) => <li key={index} ref={index === messages.length - 1 ? latest : null} className="ta-query" dir="auto">
        {message.query || tr('Search using the attached requirements.', 'ابحث باستخدام المتطلبات المرفقة.')}
        {message.document_name && <small><i className="fa-solid fa-paperclip" aria-hidden="true" /> {message.document_name}</small>}
      </li>)}</ol>
    </div>
  </div>;
}
